module.exports = __webpack_public_path__ + "img/Check_Default.eb15202e.svg";